import { Status } from "../../../../../../utils/enums";

export const activitiesStatus = [Status.TO_BE_STARTED, Status.STARTED, Status.FINISHED, Status.NOT_FINISHED, Status.EXPIRED, Status.CANCEL, Status.DELETED]